import { memo } from "react"
import { usePolicy } from "../model"

export const Can = memo(
  /**
   * @param {object} props
   * @param {string} props.policyName
   * @param {string} props.action
   * @param {string} [props.id]
   * @param {string} [props.model]
   * @param {boolean} [props.suspense]
   * @param {React.ReactNode} props.children
   * @param {React.ReactNode} [props.loadingState]
   */
  ({
    policyName,
    action,
    id,
    model,
    children,
    loadingState = null,
    suspense = false
  }) => {
    const policy = usePolicy(
      policyName,
      {
        action_name: action,
        id,
        model
      },
      { suspense }
    )

    if (policy.isLoading) {
      return loadingState
    }

    if (policy.data[action]) {
      return children
    }

    return null
  }
)
